module.exports = __webpack_public_path__ + "img/inverterStatus.da95f8df.svg";